import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import ListItemText from "@material-ui/core/ListItemText";
import { GridList, GridListTile } from "@material-ui/core";
// import Swiper JS
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Scrollbar } from "swiper/core";
// import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/scrollbar/scrollbar.min.css";

import withWidth, { isWidthUp } from "@material-ui/core/withWidth";

import { css } from "react-emotion";

SwiperCore.use([Scrollbar]);

const swiperContainer = css`
  /* width: 100%;
  height: 100%; */
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
  width: 100%;
  /* 320px — 480px: Mobile devices
481px — 768px: iPads, Tablets */
  @media only screen and (min-width: 320px) {
    width: 300px;
  }
  @media only screen and (min-width: 480px) {
    width: 400px;
  }
`;
const swiperSlide = css`
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
  @media only screen and (min-width: 320px) {
    width: 300px !important;
  }
  @media only screen and (min-width: 480px) {
    width: 400px !important;
  }
`;

const container = css`
  height: auto;
  min-height: 58px;
  transition: all 0.5s;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  position: relative;
  background: white;
  overflow: hidden;
  margin: 0px auto;
`;

const useStyles = makeStyles((theme) => ({
  container: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
    padding: "24px",
    borderLeftWidth: 0,
    borderRightWidth: 0,
  },
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: "white",
    marginLeft: "4%",
  },
  gridList: {
    flexWrap: "nowrap",
    transform: "translateZ(0)",
    height: "100px",
    width: "100%",
    marginLeft: "4%",
  },

  chatSection: {
    width: "100%",
  },
  messageArea: {
    overflowY: "auto",
  },
  messageContainer: {
    "&:hover": {
      background: "rgba(137, 210, 211, 0.3)",
    },
  },
  customTile: {
    marginRight: "10px",
    height: "100px!important",
    maxWidth: "400px",
  },
}));

const SocialFeed = (props) => {
  const classes = useStyles();
  const { feed, apps } = props;
  if (!feed || !apps) return null;
  // console.dir(apps);

  const getGridListCols = () => {
    if (isWidthUp("xl", props.width)) {
      return 4;
    }

    if (isWidthUp("lg", props.width)) {
      return 3;
    }

    if (isWidthUp("md", props.width)) {
      return 2;
    }

    return 1;
  };

  const getRowWrapStyle = () => {
    if (isWidthUp("xl", props.width)) {
      return "nowrap";
    }

    if (isWidthUp("lg", props.width)) {
      return "nowrap";
    }

    if (isWidthUp("md", props.width)) {
      return "nowrap";
    }

    return "wrap";
  };

  const parseDate = (date) => {
    return new Date(date).toLocaleString("en-US");
  };
  const getMetaData = (appId, dataType) => {
    let path = null;
    apps.map((app) => {
      if (dataType === "landingPagePath") {
        if (app.appId === appId && app.landingPagePath) {
          if (process.env.NODE_ENV === "prod") {
            path = "https://www.mobile360.io/" + app.landingPagePath;
          } else {
            path =
              "http://mobile360-qa.s3-website-us-west-1.amazonaws.com/" +
              app.landingPagePath;
          }
        }
      }
      if (dataType === "logoUrl") {
        if (app.appId === appId && app.logoUrl) {
          path = app.logoUrl;
        }
      }
    });
    return path;
  };
  if (!isWidthUp("md", props.width)) {
    return (
      <div className={container}>
        <Swiper
          // spaceBetween={10}
          scrollbar={{
            hide: false,
            draggable: true,
          }}
          slidesPerView={1}
          className={swiperContainer}
        >
          {feed.map((feedObject) => {
            return (
              <SwiperSlide
                key={feedObject.id}
                // classes={{ root: classes.customTile }}
                className={swiperSlide}
                cols={1}
              >
                <a
                  style={{
                    textDecoration: "none",
                    cursor: "pointer",
                    color: "black",
                  }}
                  href={getMetaData(feedObject.appId, "landingPagePath")}
                  target="_blank"
                >
                  <div
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                      alignItems: "center",
                      padding: "0px 10px",
                    }}
                  >
                    <img
                      src={getMetaData(feedObject.appId, "logoUrl")}
                      style={{
                        width: "60px",
                        marginRight: "20px",
                        borderRadius: "5px",
                      }}
                    />
                    <div>
                      <ListItemText
                        align="left"
                        primary={feedObject.appName}
                      ></ListItemText>

                      <ListItemText
                        align="left"
                        secondary={feedObject.description}
                      ></ListItemText>

                      <ListItemText
                        align="left"
                        secondary={parseDate(feedObject.createdDate)}
                      ></ListItemText>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  }

  return (
    // <div className={classes.container}>
    <div className={classes.root}>
      <GridList
        className={classes.gridList}
        // spacing={15}
        // cellHeight={400}
        cols={getGridListCols()}
        style={{ flexWrap: getRowWrapStyle() }}
      >
        {feed.map((feedObject) => {
          return (
            <GridListTile
              key={feedObject.id}
              // classes={{ root: classes.customTile }}
              cols={1}
            >
              <a
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                  color: "black",
                }}
                href={getMetaData(feedObject.appId, "landingPagePath")}
                target="_blank"
              >
                <div
                  style={{
                    display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "0px 10px",
                  }}
                >
                  <img
                    src={getMetaData(feedObject.appId, "logoUrl")}
                    style={{
                      width: "60px",
                      marginRight: "20px",
                      borderRadius: "5px",
                    }}
                  />
                  <div>
                    <ListItemText
                      align="left"
                      primary={feedObject.appName}
                    ></ListItemText>

                    <ListItemText
                      align="left"
                      secondary={feedObject.description}
                    ></ListItemText>

                    <ListItemText
                      align="left"
                      secondary={parseDate(feedObject.createdDate)}
                    ></ListItemText>
                  </div>
                </div>
              </a>
            </GridListTile>
          );
        })}
      </GridList>
    </div>
    // </div>
  );
};

export default withWidth()(SocialFeed);
